import { proNavigator } from "single-spa/react-app/ProNavigator";
import { isIncludeSubDomains } from "app/UtilitiesAndConstants/UtilityFunctions/common";
import DurationService from "app/services/DurationService";
import type {
    IFilters,
    IRawData,
    ITableData,
} from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/types";
import { numberFilter } from "app/filters/ngFilters";
import type { ITableSort } from "app/components/React/Table/types";
import { DefaultFetchService } from "app/services/fetchService";
import { recordsSorterHof } from "app/UtilitiesAndConstants/UtilityFunctions/sort";
import { AVAILABLE_AGES } from "app/UtilitiesAndConstants/Constants/age";
import type { IAgeBucketIDs } from "app/UtilitiesAndConstants/types/age";
import type { IChosenItem } from "../../../../../app/@types/chosenItems";

const ENDPOINT = "widgetApi/DemographicSegments/Buckets/Table";

const resolveAgeBucketForApi = (ageBucketIDs: IAgeBucketIDs): string => {
    const bucketsForApi = AVAILABLE_AGES.filter((age) => ageBucketIDs.includes(age.id))
        .map(({ api }) => api)
        .toString();
    return bucketsForApi;
};
export const getQueryParams = (filters: IFilters) => {
    const { isWWW, country, duration, webSource, key } = proNavigator.getParams();
    const includeSubDomains = isIncludeSubDomains(isWWW);
    const { from, to } = DurationService.getDurationData(duration).forAPI;
    const { genderID, ageBucketIDs } = filters;
    const ageBuckets = ageBucketIDs.length ? resolveAgeBucketForApi(ageBucketIDs) : [AVAILABLE_AGES[0].api];
    const initialFilters = {
        from,
        to,
        country,
        webSource,
        includeSubDomains,
        keys: key,
        ageBuckets,
        // retrieve male data only if male or all where selected
        maleData: ["male", "all"].includes(genderID),
        // retrieve female data only if female or all or non where selected i.e female is the default value
        femaleData: genderID !== "male",
    };
    return initialFilters;
};

export const transformData = (data: IRawData = {}, sort: ITableSort, chosenItems: Array<IChosenItem>): ITableData => {
    const chosenItemsFavicons = chosenItems.reduce((result, { name, icon }) => ({ [name]: icon, ...result }), {});
    const domains = Object.keys(data);
    const records = domains.map((domain) => {
        const { PagesPerVisit: pagesPerVisit } = data[domain];
        const record = {
            ...data[domain],
            Domain: domain,
            Favicon: chosenItemsFavicons[domain],
            PagesPerVisit: Number(numberFilter()(pagesPerVisit, 2)),
        };
        return record;
    });
    const sortedRecords = records.sort(recordsSorterHof(sort));
    const tableData = { Records: sortedRecords };
    return tableData;
};

export const fetchData = (filters: IFilters): Promise<IRawData> => {
    const queryParams = getQueryParams(filters);
    const fetchService = DefaultFetchService.getInstance();
    const rawDataPromise = fetchService.get<IRawData>(ENDPOINT, queryParams);
    return rawDataPromise;
};
